module.exports = __webpack_public_path__ + "img/DE00499.3c5c3706.png";